<template>
  <component
    :is="tag"
    :class="[
      ns.b(),
      ns.is(`justify-${props.justify}`, justify !== 'start'),
      ns.is(`items-${props.items}`, items !== 'start'),
    ]"
    :style="style"
    data-test-name="row"
    data-test-variant=""
    data-test-state=""
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'
import { useNamespace } from '@bigin/hooks'
import { rowContextKey } from '@bigin/tokens'
import { isString } from '@bigin/utils'
import { rowProps } from './row'
import type { CSSProperties } from 'vue'

defineOptions({
  name: 'BRow',
})

const props = defineProps(rowProps)

const ns = useNamespace('row')
const gutter = computed(() =>
  isString(props.gutter) ? Number.parseInt(`${props.gutter}`) : props.gutter
)

provide(rowContextKey, {
  gutter,
})

const style = computed(() => {
  const styles: CSSProperties = {}
  if (!props.gutter) {
    return styles
  }

  styles.marginRight = styles.marginLeft = `-${gutter.value * 2}px`
  return styles
})
</script>
